import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { MdDeliveryDining, MdOutlineShoppingBasket } from "react-icons/md";
import { FaRegCheckCircle } from "react-icons/fa";
import "./AOD.css";
import { toast } from "react-toastify";
import { setError } from "../services/actions";
import { useDispatch } from "react-redux";

const ActiveOrderDetail = () => {
  const [activeOrder, setActiveOrder] = useState();
  const [activeOrderDetail, setActiveOrderDetail] = useState();
  const [price, setPrice] = useState();
  const loc = useLocation();
  const [cart, setCart] = useState(false);
  const [orderStatus, setOrderStatus] = useState(true);
  const [cancel, setCancel] = useState(false);
  const [reason, setReason] = useState(false);
  const first = JSON.parse(localStorage.getItem("item"));
  const reasonInput = useRef();
  const nav = useNavigate();
  const [deliveryStatus, setDeliveryStatus] = useState();
  const diapach = useDispatch();

  useEffect(() => {
    console.log(first);
    setActiveOrderDetail(JSON.stringify(first));
    var user = JSON.parse(localStorage.getItem("user"));
    var data = {
      user_id: user.user_id,
      server_token: user.server_token,
      order_id: first._id,
    };
    setPrice(loc.state.item);
    console.log(loc.state.item.total_order_price);
    Get_order_status(data);
  }, []);

  const Get_order_status = function (data) {
    // active order detail on active orders page
    var body = data;
    body = JSON.stringify(body);
    axios
      .post("http://196.189.44.49:7000/api/user/get_order_status", body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          if (res.data.success == true) {
            setActiveOrder(res.data);
            setDeliveryStatus(activeOrder.deliveryStatus);
            console.log(deliveryStatus);
            console.log(activeOrderDetail && activeOrderDetail);
          } else {
            console.log(res.data.error_code);
          }
        } else {
          // do something
        }
      })
      .catch((err) => {
        // do something
      });
  };

  const Cancel_Order = function (data) {
    // Cancel page on Active order detail
    var body = data;
    body = JSON.stringify(body);
    axios
      .post("http://196.189.44.49:7000/api/user/user_cancel_order", body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          if (res.data.success == true) {
            // you would get something here
            alert("Canceled Successfully");
            nav("/order");
          } else {
            console.log(res.data.error_code);
            if (res.data.error_code == 999) {
              console.log(true);
              toast.error("Please Login !", {
                position: toast.POSITION.TOP_RIGHT,
              });
              localStorage.clear();
              window.location.reload();
              console.log("sdfgh");
            } else {
              diapach(
                setError({
                  error: true,
                  message: `failed, please check again(${res.data.error_code})`,
                })
              );
            }
          }
        } else {
          // do something
          if (res.data.error_code == 999) {
            console.log(true);
            toast.error("Please Login !", {
              position: toast.POSITION.TOP_RIGHT,
            });
            localStorage.clear();
            window.location.reload();
            console.log("sdfgh");
          } else {
            diapach(
              setError({
                error: true,
                message: `failed, please check again(${res.data.error_code})`,
              })
            );
          }
        }
      })
      .catch((err) => {
        // do something
        diapach(setError({ error: true, message: "failed,please reload" }));
      });
  };

  const Submit_Order = function (data) {
    // Submit order or complete order or show invoice
    var body = data;
    body = JSON.stringify(body);
    axios
      .post("http://196.189.44.49:7000/api/user/show_invoice", body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          if (res.data.success == true) {
            // you would get something here
            localStorage.setItem("item", JSON.stringify(first));
            nav("/order-history-detail", {
              state: {
                item: {
                  value: first,
                },
              },
            });
          } else {
            console.log("erororor", res.data.error_code);
            if (res.data.error_code == 999) {
              console.log(true);
              toast.error("Please Login !", {
                position: toast.POSITION.TOP_RIGHT,
              });
              localStorage.clear();
              window.location.reload();
              console.log("sdfgh");
            } else {
              diapach(
                setError({
                  error: true,
                  message: `failed, please check again(${res.data.error_code})`,
                })
              );
            }
          }
        } else {
          // do something
          if (res.data.error_code == 999) {
            console.log(true);
            toast.error("Please Login !", {
              position: toast.POSITION.TOP_RIGHT,
            });
            localStorage.clear();
            window.location.reload();
            console.log("sdfgh");
          } else {
            diapach(
              setError({
                error: true,
                message: `failed, please check again(${res.data.error_code})`,
              })
            );
          }
        }
      })
      .catch((err) => {
        // do something
        diapach(setError({ error: true, message: "failed,please reload" }));
      });
  };

  const handleCancel = () => {
    var user = JSON.parse(localStorage.getItem("user"));
    var data = {
      user_id: user.user_id,
      server_token: user.server_token,
      cancel_reason: reasonInput.current.value,
      order_id: first._id,
    };
    Cancel_Order(data);
  };

  const handleSubmit = () => {
    var user = JSON.parse(localStorage.getItem("user"));
    var data = {
      user_id: user.user_id,
      server_token: user.server_token,
      order_id: first._id,
      is_user_show_invoice: true,
    };
    Submit_Order(data);
  };

  return (
    <div className="a-active-order-detail-page">
      <div className="a-active-order-info">
        <div className="a-buttons">
          <button
            className={orderStatus ? "btn-active" : ""}
            onClick={() => {
              setOrderStatus(true);
              setCart(false);
            }}
          >
            <MdDeliveryDining size={25} color="var(--primary-color)" />
            <br />
            Order Status
          </button>
          <button
            className={cart ? "btn-active" : ""}
            onClick={() => {
              setOrderStatus(false);
              setCart(true);
              setCancel(false);
            }}
          >
            <MdOutlineShoppingBasket size={25} color="var(--primary-color)" />
            <br />
            Cart
          </button>
        </div>
        <div className={orderStatus ? "page page-active" : "page"}>
          <div className="a-total-description">
            <p>
              Total Price: {activeOrder && activeOrder.currency}&nbsp;
              {price && price.total_order_price}
            </p>
            <p>ORDER ID: #{activeOrder && activeOrder.unique_id}</p>
          </div>
          <div className="a-store-description">
            <p>Store: {price && price.store_name}</p>
          </div>
          <div className="a-delivery-description">
            <p>DELIVERY ADDRESS</p>
            <p>{price && price.destination_addresses[0].address}</p>
          </div>
          <div className="a-status-description">
            <div>
              <div className="bullet">
                <FaRegCheckCircle
                  color={
                    activeOrder && activeOrder.order_status >= 1
                      ? "var(--primary-color)"
                      : ""
                  }
                />
              </div>{" "}
              Waiting for the store to accept
            </div>
            <div>
              <div className="bullet">
                <FaRegCheckCircle
                  color={
                    activeOrder && activeOrder.order_status >= 1
                      ? "var(--primary-color)"
                      : ""
                  }
                />
              </div>{" "}
              Store Accepted
            </div>
            <div>
              <div className="bullet">
                <FaRegCheckCircle
                  color={
                    activeOrder && activeOrder.order_status >= 1
                      ? "var(--primary-color)"
                      : ""
                  }
                />
              </div>{" "}
              Store Preparing Order
            </div>
            <div>
              <div className="bullet">
                <FaRegCheckCircle
                  color={
                    activeOrder && activeOrder.order_status >= 25
                      ? "var(--primary-color)"
                      : ""
                  }
                />
              </div>{" "}
              Order ready
            </div>
            <div>
              <div className="bullet">
                <FaRegCheckCircle
                  color={
                    activeOrder && activeOrder.order_status >= 25
                      ? "var(--primary-color)"
                      : ""
                  }
                />
              </div>{" "}
              Delivery man Accepted
            </div>
            <div>
              <div className="bullet">
                <FaRegCheckCircle
                  color={
                    activeOrder && activeOrder.order_status >= 25
                      ? "var(--primary-color)"
                      : ""
                  }
                />
              </div>{" "}
              Delivery man going to store
            </div>
            <div>
              <div className="bullet">
                <FaRegCheckCircle
                  color={
                    activeOrder && activeOrder.order_status >= 25
                      ? "var(--primary-color)"
                      : ""
                  }
                />
              </div>{" "}
              Delivery man arrived at the store
            </div>
            <div>
              <div className="bullet">
                <FaRegCheckCircle
                  color={
                    activeOrder && activeOrder.order_status >= 25
                      ? "var(--primary-color)"
                      : ""
                  }
                />
              </div>{" "}
              Delivery man picked order
            </div>
            <div>
              <div className="bullet">
                <FaRegCheckCircle
                  color={
                    activeOrder && activeOrder.order_status >= 25
                      ? "var(--primary-color)"
                      : ""
                  }
                />
              </div>{" "}
              Delivery man started delivery
            </div>
            <div>
              <div className="bullet">
                <FaRegCheckCircle
                  color={
                    activeOrder && activeOrder.order_status >= 25
                      ? "var(--primary-color)"
                      : ""
                  }
                />
              </div>{" "}
              Delivery man arrived at your location
            </div>
            <div>
              <div className="bullet">
                <FaRegCheckCircle
                  color={
                    activeOrder && activeOrder.order_status >= 25
                      ? "var(--primary-color)"
                      : ""
                  }
                />
              </div>{" "}
              Delivery man completed delivery
            </div>
          </div>
        </div>
        <div
          className={
            activeOrder &&
            (activeOrder.delivery_status < 25
              ? "page page-active a-buttons-bottom"
              : "page a-buttons-bottom")
          }
          style={{
            display: !orderStatus && "none",
          }}
        >
          <button
            className="a-btn-cancel"
            onClick={(e) => {
              e.preventDefault();
              setCancel(true);
            }}
          >
            Cancel
          </button>
        </div>
        <div
          className={
            activeOrder &&
            (activeOrder.delivery_status >= 25 ? "page page-active" : "page")
          }
        >
          <button className="a-btn-cancel" onClick={handleSubmit}>
            Submit
          </button>
        </div>
        {cancel ? (
          <div
            /* className={cancel ? "page page-active" : "page"} */ className="a-main"
          >
            <div className="a-popup">
              <form>
                <p>Keep Order</p>
                <label>Are you sure you want to cancel</label>
                <br />
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setCancel(false);
                  }}
                  style={{
                    color: "var(--primary-color)",
                  }}
                >
                  Think about it
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setReason(true);
                  }}
                >
                  Sure
                </button>
              </form>
            </div>
            {reason ? (
              <div /* className={reason ? "page page-active" : "page"} */
                className="a-popup"
              >
                <form>
                  <p>Reason ☹️</p>
                  <input
                    type="text"
                    ref={reasonInput}
                    style={{ width: "100%" }}
                  />
                  <br />
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setReason(false);
                      setCancel(false);
                    }}
                    style={{
                      color: "var(--primary-color)",
                    }}
                  >
                    Think about it
                  </button>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setCancel(false);
                      setReason(false);
                      handleCancel();
                    }}
                  >
                    Sure
                  </button>
                </form>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </div>
      <div className={cart ? "page page-active" : "page"}>
        {first.order_details.map((od) => {
          return [
            <div className="a-product-name">
              <h3>{od.product_name}</h3>
            </div>,
            <div className="a-product-item">
              {od.items.map((i) => {
                return [
                  <div>
                    <p className="a-item-name">{i.item_name}</p>
                    <p className="a-item-quantity">Quantity: {i.quantity}</p>
                  </div>,
                  <p className="a-item-price">
                    {first.currency} {i.total_item_price}
                  </p>,
                ];
              })}
            </div>,
          ];
        })}
        <br />
        <div className="a-total-price">
          <h5>
            Total Price: {first.currency} {first.total_order_price}
          </h5>
        </div>
      </div>
    </div>
  );
};

export default ActiveOrderDetail;
